export const CREATE_WEBSOCKET_CONNECTION = 'CREATE_WEBSOCKET_CONNECTION';
export const CLOSE_WEBSOCKET_CONNECTION = 'CLOSE_WEBSOCKET_CONNECTION';

export const createGrochatWebsocketConnection = websocket => {
    return {
        type: CREATE_WEBSOCKET_CONNECTION,
        payload: websocket
    }
}

export const closeGrochatWebsocketConnection = () => {
    return {
        type: CLOSE_WEBSOCKET_CONNECTION
    }
}

